import SaitoSlip from 'saito-js/lib/slip';

export default class Slip extends SaitoSlip {
  public constructor(data?: any, json?: any) {
    super(data, json);
  }
}
